import React, { useState, useEffect } from 'react';
import { cityService } from '../../api/cityService';
import { uploadService } from '../../api/uploadService';
import '../Common/Common.css';

function CityForm({ city, onSuccess, onCancel }) {
  const [formData, setFormData] = useState({
    name: '',
    is_active: true,
    delivery_fee: 0,
  });
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (city) {
      setFormData({
        name: city.name || '',
        is_active: city.is_active ?? true,
        delivery_fee: city.delivery_fee || 0,
      });
      
    }
  }, [city]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    try {
      if (city) {
        await cityService.updateCity(city.id, formData);
      } else {
        await cityService.createCity(formData);
      }
      onSuccess();
    } catch (error) {
      console.error('Error saving city:', error);
      alert('Échec de l\'enregistrement de la ville');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="form">
      <div className="form-group">
        <label htmlFor="title">Nom </label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          className="form-control"
          placeholder="Titre du city"
        />
      </div>

      <div className="form-group">
        <label htmlFor="position">Frais de livraison</label>
        <input
          type="number"
          id="delivery_fee"
          name="delivery_fee"
          value={formData.delivery_fee}
          onChange={handleChange}
          className="form-control"
          min="0"
          required
        />
      </div>

      <div className="form-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            name="is_active"
            checked={formData.is_active}
            onChange={handleChange}
          />
          <span>Actif</span>
        </label>
      </div>

      <div className="form-actions">
        <button type="button" onClick={onCancel} className="btn btn-secondary">
          Annuler
        </button>
        <button type="submit" disabled={loading} className="btn btn-primary">
          {loading ? 'Enregistrement...' :  city ? 'Modifier' : 'Créer'}
        </button>
      </div>
    </form>
  );
}

export default CityForm;
